<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="animated fadeIn" cols="12">
        <c-paginate table-uri="paginate/table/banners" caption="Publicación de banners"  :fields="fields" avatar-key-name="imagenes_id_avatar" new-item-name="Nuevo banner" edit-name="Detalle de banner"></c-paginate>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'

  export default {
    name: 'UsuariosIndex',
    data: () => {
      return {
        fields: [
          {
            key: 'imagenes_id',
            label: 'Banner'
          },
          {
            key: 'titulo',
            label: 'Título del banner'
          },
          {
            key: 'estatus',
            label: 'Estatus'
          },
          {
            key: '_',
            label: ' '
          }
        ]
      }
    }
  }

</script>
